module.exports = __webpack_public_path__ + "static/media/code.4a486cff.svg";